import {Component, HostListener} from '@angular/core';
import {IncidentReportsService} from '../../../services/incident-reports.service';
import {UrlService} from '../../../services/url.service';

declare const toastr: any;
declare const $: any;

@Component({
    selector: 'incident-reports-list',
    templateUrl: './incident-reports-list.component.html',
    styleUrls: ['./incident-reports-list.component.scss']
})
export class IncidentReportsListComponent {

    constructor(
        public urlService: UrlService,
        public incidentReportsService: IncidentReportsService
    ) {}

    orderBy(orderBy: string, $event) {
        if (this.incidentReportsService.data.allIncidentReports.total < 2) return;
        this.urlService.orderBy(orderBy, $event);
    }

    showHint(e) {
        const $td = $(e.target).closest('.incident-reports-hint-td');
        if ($td.hasClass('active'))
            $td.removeClass('active');
        else {
            $('.incident-reports-hint-td').removeClass('active');
            $td.addClass('active');
        }
    }

    toggleCheck(selectedItem): void {
        const checked = selectedItem.checked;
        this.incidentReportsService.data.allIncidentReports.data.forEach(item => item.checked = false);
        if (checked && this.incidentReportsService.selectedItemData) {
            this.incidentReportsService.selectedItemData = null;
            this.incidentReportsService.toggleDetailedView(null, false);
            selectedItem.checked = false;
        } else {
            this.incidentReportsService.selectedItemData = selectedItem;
            selectedItem.checked = true;
            this.incidentReportsService.toggleDetailedView(selectedItem, true);
        }
    }

    @HostListener('document:click', ['$event.target'])
    hideHint(targetElement: HTMLElement): void {
        if (!$(targetElement).closest('.incident-reports-hint-td').length) {
            $('.incident-reports-hint-td').removeClass('active');
        }
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/incident-reports/incident-reports-list/incident-reports-list.component.ts